(function () {
  // ---------------------------------------------------------------------------
  // v2 activation layer — theme-agnostic.
  //
  // Instead of shipping theme-specific markup, this script FINDS the theme's
  // own checkout button(s) in the DOM (Dawn, Horizon, most third-party themes
  // all render one) and injects a Kustom button right next to each, inheriting
  // the native button's styling. A gate then decides per visitor which of the
  // two is visible, driven by the merchant's Theme settings, exposed via
  // snippets/kustom-config.liquid as window.__kustomCheckout:
  //   - kill switch  (enabled: false disables — native checkout untouched)
  //   - market scope (markets: "SE,NO"; blank = all markets)
  //   - A/B split    (split: 0..100 = % of shoppers shown Kustom; sticky per
  //                   visitor via cookie; ?kustom_ab=kustom|control|reset
  //                   forces/pins an arm for QA)
  //   - cart content (a cart with a subscription / selling plan always shows
  //                   the store's own checkout button — Kustom can't take
  //                   subscription orders; see refreshCartState)
  //
  // Reversibility: the native button is never removed — only hidden inline for
  // the Kustom arm — so if this script doesn't run (kill switch, JS error,
  // uninstall) the merchant's original checkout works exactly as before.
  //
  // Back-compat: older installs replaced snippets/cart-summary.liquid with a
  // pre-rendered [data-kustom-cta] block; those blocks are still gated here
  // and are excluded from injection.
  // ---------------------------------------------------------------------------
  var COOKIE = 'kustom_ab';
  var COOKIE_MAXAGE = 60 * 60 * 24 * 180; // 180 days
  var currentVariant = null;

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  // QA preview override: ?kustom_ab=kustom (or control) forces that arm and
  // pins it via the cookie; ?kustom_ab=reset clears the pin.
  function previewOverride() {
    var m = window.location.search.match(/[?&]kustom_ab=(kustom|control|reset)\b/);
    if (!m) return null;
    if (m[1] === 'reset') {
      document.cookie = COOKIE + '=;path=/;max-age=0;SameSite=Lax';
      return null;
    }
    document.cookie = COOKIE + '=' + m[1] + ';path=/;max-age=' + COOKIE_MAXAGE + ';SameSite=Lax';
    return m[1];
  }

  function assignBucket(split) {
    if (split >= 100) return 'kustom';
    if (split <= 0) return 'control';
    var existing = readCookie(COOKIE);
    if (existing === 'kustom' || existing === 'control') return existing;
    var b = Math.random() * 100 < split ? 'kustom' : 'control';
    document.cookie = COOKIE + '=' + b + ';path=/;max-age=' + COOKIE_MAXAGE + ';SameSite=Lax';
    return b;
  }

  function parseSplit(raw) {
    if (raw === '' || raw === null || raw === undefined) return 100;
    var n = parseInt(raw, 10);
    return isNaN(n) ? 100 : Math.max(0, Math.min(100, n));
  }

  // Global config from snippets/kustom-config.liquid (theme settings + market
  // context). Missing config fails open to "enabled, all markets, 100%".
  function globalConfig() {
    var c = window.__kustomCheckout || {};
    return {
      enabled: c.enabled !== false,
      markets: typeof c.markets === 'string' ? c.markets : '',
      split: parseSplit(typeof c.split === 'number' ? String(c.split) : c.split),
      country: String(c.country || (window.Shopify && window.Shopify.country) || 'SE').toUpperCase(),
      currency: c.currency || null,
      locale: c.locale || null,
    };
  }

  // Legacy pre-rendered blocks carry their own config as data-attributes.
  function blockConfig(cta) {
    return {
      enabled: cta.dataset.kustomEnabled !== 'false',
      markets: (cta.dataset.kustomMarkets || '').trim(),
      split: parseSplit((cta.dataset.kustomAbSplit || '').trim()),
      country: (cta.dataset.country || 'SE').toUpperCase(),
      currency: null,
      locale: null,
    };
  }

  function decide(cfg) {
    var forced = previewOverride();
    if (forced) return { active: forced === 'kustom', variant: forced, country: cfg.country, preview: true };
    if (!cfg.enabled) return { active: false, variant: 'control', country: cfg.country };
    var markets = cfg.markets ? cfg.markets.toUpperCase().split(/[^A-Z]+/).filter(Boolean) : null;
    if (markets && markets.length && markets.indexOf(cfg.country) === -1) {
      return { active: false, variant: 'control', country: cfg.country };
    }
    var bucket = assignBucket(cfg.split);
    return { active: bucket === 'kustom', variant: bucket, country: cfg.country };
  }

  // Persist the assigned experience onto the cart so BOTH native and Kustom
  // orders carry it (Shopify writes cart attributes onto the order). Once per
  // page-session to avoid repeat writes.
  function tagCart(variant, country) {
    try {
      if (sessionStorage.getItem('kustom_ab_tagged') === variant + '|' + country) return;
    } catch (e) { /* sessionStorage unavailable */ }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'kustom-experience': variant, 'kustom-market': country } }),
    }).then(function () {
      try { sessionStorage.setItem('kustom_ab_tagged', variant + '|' + country); } catch (e) {}
    }).catch(function () {});
  }

  // Same label as a normal checkout button, in every market — the shopper
  // shouldn't see a payment brand on the button.
  function buttonLabel() {
    return 'Checkout';
  }

  // Inline show/hide that survives theme CSS (the [hidden] UA rule is often
  // overridden by theme .button display rules). Original display is remembered
  // so revert is exact.
  function setVisible(el, visible) {
    if (!el) return;
    if (visible) {
      el.style.display = el.getAttribute('data-kustom-display') || '';
    } else {
      if (!el.hasAttribute('data-kustom-display')) el.setAttribute('data-kustom-display', el.style.display || '');
      el.style.display = 'none';
    }
  }

  // The theme's own checkout controls, across Dawn / Horizon / most themes.
  var NATIVE_SELECTOR = 'button[name="checkout"], input[name="checkout"], .cart__checkout-button, a[href="/checkout"], a[href^="/checkout?"]';

  function injectButtons(cfg) {
    document.querySelectorAll(NATIVE_SELECTOR).forEach(function (nativeBtn) {
      if (nativeBtn.hasAttribute('data-kustom-native') || nativeBtn.hasAttribute('data-kustom-checkout')) return;
      if (nativeBtn.closest('[data-kustom-cta]')) return; // legacy block manages its own pair
      nativeBtn.setAttribute('data-kustom-native', '');

      var k = document.createElement('button');
      k.type = 'button';
      k.className = nativeBtn.className; // inherit the theme's button styling
      // Inline styles too: some themes size the button directly on the element
      // (e.g. style="width: 100%" — seen on switch-nails.com's "Revolution"
      // theme), and without them the Kustom button rendered 117px wide and
      // centred where the native one was full width. display is managed by
      // setVisible, so drop it from the copy.
      if (nativeBtn.getAttribute('style')) {
        k.style.cssText = nativeBtn.style.cssText;
        k.style.removeProperty('display');
      }
      k.classList.add('kustom-btn');
      k.setAttribute('data-kustom-checkout', '');
      k.setAttribute('data-kustom-injected', '');
      k.setAttribute('data-country', cfg.country);
      if (cfg.currency) k.setAttribute('data-currency', cfg.currency);
      if (cfg.locale) k.setAttribute('data-locale', cfg.locale);
      var span = document.createElement('span');
      span.className = 'button-text';
      span.textContent = buttonLabel(cfg);
      k.appendChild(span);
      setVisible(k, false);

      var err = document.createElement('p');
      err.className = 'kustom-btn-error';
      err.setAttribute('style', 'color:#b91c1c;font-size:13px;margin-top:8px;display:none;');

      nativeBtn.insertAdjacentElement('afterend', err);
      nativeBtn.insertAdjacentElement('afterend', k);
    });
  }

  // ---------------------------------------------------------------------------
  // Subscriptions: a cart containing a selling plan (Shopify subscriptions,
  // e.g. SEAL Subscriptions) can't be paid with Kustom, so the shopper gets the
  // store's own checkout button instead — no Kustom button that redirects.
  // Cart state is read on page show and, throttled, whenever the DOM changes
  // (cart drawers re-render after add/remove). The click handler and the
  // Worker enforce the same rule as a fallback.
  // ---------------------------------------------------------------------------
  var cartHasSubscription = false;
  var lastCartCheck = 0;
  var cartCheckPending = null;

  function hasSubscriptionItems(items) {
    return (items || []).some(function (i) { return !!i.selling_plan_allocation; });
  }

  function refreshCartState(force) {
    var now = Date.now();
    if (!force && now - lastCartCheck < 1500) return cartCheckPending || Promise.resolve();
    lastCartCheck = now;
    cartCheckPending = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var before = cartHasSubscription;
        cartHasSubscription = hasSubscriptionItems(cart.items);
        if (before !== cartHasSubscription) applyGate();
      })
      .catch(function () { /* best-effort — the click handler still guards */ })
      .then(function () { cartCheckPending = null; });
    return cartCheckPending;
  }

  function applyGate() {
    var cfg = globalConfig();
    var d = decide(cfg);
    currentVariant = d.variant;
    // Subscription carts always get the native button, regardless of arm
    var showKustom = d.active && !cartHasSubscription;

    // Injected pairs (theme-agnostic path)
    injectButtons(cfg);
    document.querySelectorAll('[data-kustom-native]').forEach(function (nativeBtn) {
      if (nativeBtn.closest('[data-kustom-cta]')) return;
      var k = nativeBtn.nextElementSibling;
      if (!k || !k.hasAttribute('data-kustom-checkout')) return;
      setVisible(k, showKustom);
      setVisible(nativeBtn, !showKustom);
      if ('disabled' in nativeBtn) k.disabled = nativeBtn.disabled;
    });

    // Legacy pre-rendered blocks (older installs) — per-block config wins
    document.querySelectorAll('[data-kustom-cta]').forEach(function (cta) {
      var bd = decide(blockConfig(cta));
      var blockActive = bd.active && !cartHasSubscription;
      var kustomBtn = cta.querySelector('[data-kustom-checkout]');
      var nativeBtn = cta.querySelector('[data-kustom-native]');
      if (kustomBtn) kustomBtn.hidden = !blockActive;
      if (nativeBtn) nativeBtn.hidden = blockActive;
      cta.dataset.kustomVariant = bd.variant;
    });

    // Subscription orders always go through Shopify — tag them separately so
    // they don't land in either A/B arm's numbers.
    tagCart(cartHasSubscription ? 'subscription' : d.variant, d.country);
  }

  function resetKustomButtons() {
    document.querySelectorAll('[data-kustom-checkout]').forEach(function (btn) {
      btn.disabled = false;
      var textEl = btn.querySelector('.button-text');
      if (textEl) textEl.textContent = buttonLabel(globalConfig());
    });
  }

  // Cart drawers and section re-renders add checkout buttons after load —
  // watch for them (childList only: our own inline-style updates don't retrigger).
  var scanScheduled = false;
  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    setTimeout(function () { scanScheduled = false; refreshCartState(); applyGate(); }, 150);
  }
  new MutationObserver(scheduleScan).observe(document.documentElement, { childList: true, subtree: true });

  // ---------------------------------------------------------------------------
  // Cart-synk (dynamisk cart): om kunden ändrat carten inne i Kustom-checkouten
  // (update_cart-callbacken uppdaterar Kustom-ordern server-side) och navigerar
  // tillbaka till butiken, speglas ändringarna till Shopifys session-cart via
  // Ajax cart API. Shopify-carten är cookie-bunden till webbläsaren och kan
  // inte uppdateras från Workern — därför sker synken här, klient-side.
  // Körs bara när Workern rapporterade dynamic_cart vid ordercreate (order-ID:t
  // sparas bara då). Best-effort: får aldrig blockera butiken.
  // ---------------------------------------------------------------------------
  function cartSignature(items) {
    return items.map(function (i) { return i.variant_id + 'x' + i.quantity; }).sort().join(',');
  }

  function forgetKustomOrder() {
    try {
      sessionStorage.removeItem('kustomOrderId');
      sessionStorage.removeItem('kustomCheckoutUrl');
      sessionStorage.removeItem('kustomCartSync');
      sessionStorage.removeItem('kustomDynamicCart');
    } catch (e) {}
  }

  async function syncCartFromKustom() {
    var orderId = null;
    try { orderId = sessionStorage.getItem('kustomOrderId'); } catch (e) {}
    if (!orderId) return;

    try {
      var res = await fetch('https://kustom-checkout-switch-nails.switch-nails.workers.dev/order-lines/' + orderId);
      if (!res.ok) { forgetKustomOrder(); return; }
      var data = await res.json();

      // Betald order: töm Shopify-carten så kunden inte kommer tillbaka till en
      // full varukorg. Måste ske här — Workern kan inte nå cart-cookien.
      // /cart/clear.js tar bara bort raderna: en rabattkod som applicerats i
      // carten ligger kvar i Shopifys session och skulle följa med nästa order,
      // så den tas bort med update.js (samma anrop temats eget rabattfält gör)
      // och kakan för /discount/-länkar rensas. Bara Ajax Cart API — temaoberoende.
      if (data.status === 'checkout_complete') {
        forgetKustomOrder();
        var current = await fetch('/cart.js').then(function (r) { return r.json(); });
        var hasDiscount = (current.discount_codes || []).length > 0 ||
          (current.cart_level_discount_applications || []).length > 0;
        if (current.item_count > 0 || hasDiscount) {
          await fetch('/cart/clear.js', { method: 'POST' });
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: '' }),
          }).catch(function () {});
          document.cookie = 'discount_code=; Max-Age=0; path=/';
          window.location.reload();
        }
        return;
      }
      // Avbruten/utgången order — sluta synka
      if (data.status !== 'checkout_incomplete') {
        forgetKustomOrder();
        return;
      }
      // Cart-synken nedan gäller bara när Workern rapporterade dynamic_cart
      var dynamic = null;
      try { dynamic = sessionStorage.getItem('kustomDynamicCart'); } catch (e) {}
      if (!dynamic) return;

      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      var cartMap = {};
      cart.items.forEach(function (i) { cartMap[String(i.variant_id)] = i.quantity; });
      var orderMap = {};
      (data.lines || []).forEach(function (l) { orderMap[String(l.variant_id)] = l.quantity; });

      // Kvantitetsändringar + borttag (0)
      var updates = {};
      var hasUpdates = false;
      Object.keys(cartMap).forEach(function (v) {
        var want = orderMap[v] || 0;
        if (want !== cartMap[v]) { updates[v] = want; hasUpdates = true; }
      });
      // Nya varor (finns i ordern men inte i carten)
      var additions = Object.keys(orderMap).filter(function (v) { return !(v in cartMap); });

      if (!hasUpdates && additions.length === 0) {
        try { sessionStorage.removeItem('kustomCartSync'); } catch (e) {}
        return;
      }

      // Loop-vakt: Shopify kan vägra applicera diffen — /cart/update.js cappar
      // tyst antal över lagersaldot och /cart/add.js svarar 422 för slutsålda
      // varor. Då förblir diffen efter omladdning, och varje pageshow skulle
      // annars trigga update + reload i all oändlighet. Har exakt samma
      // synkläge redan försökts: gör inget mer.
      var attempt = orderId + '|' + cartSignature(cart.items) + '>' + JSON.stringify(orderMap);
      try {
        if (sessionStorage.getItem('kustomCartSync') === attempt) return;
        sessionStorage.setItem('kustomCartSync', attempt);
      } catch (e) {}

      if (hasUpdates) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        });
      }
      for (var i = 0; i < additions.length; i++) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(additions[i]), quantity: orderMap[additions[i]] }),
        });
      }

      // Ladda bara om ifall carten faktiskt ändrades, så temats cart-UI
      // (drawer, badge) speglar nya innehållet. Ändrades inget (slutsåld vara,
      // cappat antal) skulle en reload bara köra samma misslyckade synk igen.
      var after = await fetch('/cart.js').then(function (r) { return r.json(); });
      if (cartSignature(after.items) !== cartSignature(cart.items)) {
        window.location.reload();
      }
    } catch (err) {
      // Tyst — synken är best-effort
    }
  }

  window.addEventListener('pageshow', function () { resetKustomButtons(); refreshCartState(true); applyGate(); syncCartFromKustom(); });
  window.addEventListener('pagereveal', function () { resetKustomButtons(); applyGate(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refreshCartState(true); applyGate(); });
  } else {
    refreshCartState(true);
    applyGate();
  }

  async function handleKustomClick(e) {
    var btn = e.target.closest('[data-kustom-checkout]');
    if (!btn || btn.disabled) return;

    var errEl = btn.parentElement && btn.parentElement.querySelector('.kustom-btn-error');
    var textEl = btn.querySelector('.button-text');
    btn.disabled = true;
    if (textEl) textEl.textContent = '…';
    if (errEl) errEl.style.display = 'none';

    try {
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });

      if (!cart.items || cart.items.length === 0) {
        window.location.reload();
        return;
      }

      // Prenumerationer (selling plans) stöds inte i Kustom Checkout. Gaten
      // visar normalt den nativa knappen för sådana cartar (refreshCartState);
      // det här är fallback om carten ändrats sedan senaste kontrollen.
      if (hasSubscriptionItems(cart.items)) {
        window.location.href = '/checkout';
        return;
      }

      // Land och locale från config/data-attribut (satt server-side, alltid korrekt)
      var country = btn.dataset.country || globalConfig().country || 'SE';

      // Valuta: använd window.Shopify.currency.active (presentment-valutan) i första hand
      // cart.currency från /cart.js är ibland butikens basvaluta, inte market-valutan
      var currency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        btn.dataset.currency ||
        'SEK';

      // Locale: bygg "sv-SE"-format från Shopify.locale + land om möjligt
      var shopifyLang = window.Shopify && window.Shopify.locale;
      var locale;
      if (shopifyLang) {
        locale = shopifyLang.includes('-') ? shopifyLang : shopifyLang + '-' + country;
      } else {
        locale = btn.dataset.locale || 'sv-SE';
      }

      var market = { country: country, currency: currency, locale: locale };
      // A/B variant assigned by the gate — the Worker stamps it on the order.
      var cta = btn.closest('[data-kustom-cta]');
      var variant = (cta && cta.dataset.kustomVariant) || currentVariant || 'kustom';
      // Checkout customization from Theme settings (customer types, separate
      // shipping address, colors) — the Worker validates every field before
      // putting any of it on the Kustom order, so a hand-edited theme can't
      // break order creation.
      var checkoutCfg = (window.__kustomCheckout && window.__kustomCheckout.checkout) || null;

      // Pågående order från ett tidigare klick: Workern uppdaterar och
      // återanvänder den om den fortfarande går att slutföra, så rabattkod,
      // adress och fraktval i checkouten inte försvinner vid ett varv tillbaka
      // till butiken.
      var existing = null;
      try {
        var prevId = sessionStorage.getItem('kustomOrderId');
        var prevUrl = sessionStorage.getItem('kustomCheckoutUrl');
        if (prevId && prevUrl) existing = { order_id: prevId, checkout_url: prevUrl };
      } catch (e) {}

      var res = await fetch('https://kustom-checkout-switch-nails.switch-nails.workers.dev/create-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({}, cart, { _market: market, _variant: variant, _checkout: checkoutCfg, _existing: existing })),
      });
      var data = await res.json();
      if (data.checkout_url) {
        // Spara order-ID:t och checkout-URL:en: för återanvändning vid nästa
        // klick, för att tömma carten när ordern är betald, och — om Workern
        // har dynamic_cart påslagen — för cart-synk. Se syncCartFromKustom.
        try {
          if (data.order_id) {
            sessionStorage.setItem('kustomOrderId', data.order_id);
            sessionStorage.setItem('kustomCheckoutUrl', data.checkout_url);
            sessionStorage.setItem('kustomDynamicCart', data.dynamic_cart ? '1' : '');
          }
        } catch (e) {}
        window.location.href = data.checkout_url;
      } else {
        throw new Error(data.error || 'Något gick fel');
      }
    } catch (err) {
      btn.disabled = false;
      if (textEl) textEl.textContent = buttonLabel(globalConfig());
      if (errEl) { errEl.textContent = err.message; errEl.style.display = 'block'; }
      // Emergency fallback: if Kustom can't start, put the native checkout back
      // so the shopper is never stranded.
      var nb = btn.previousElementSibling;
      if (nb && nb.hasAttribute && nb.hasAttribute('data-kustom-native')) setVisible(nb, true);
    }
  }

  document.addEventListener('click', handleKustomClick);
})();
